import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type DeleteAppointmentNotePayload = {
  appointment_note_id: number;
};

export const useDeleteAppointmentNoteMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DeleteAppointmentNotePayload) => {
      await ApiInstance.post("/notes/delete", payload);
    },
    onSuccess: ({ appointment_note_id }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.notes) return;

      const noteIdx = appointment.notes.findIndex(note => note.id === appointment_note_id);
      if (noteIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, notes: appointment.notes.toSpliced(noteIdx, 1) });
    }
  });
